import { Form, Row } from 'antd';
import React, { useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import FormWrapper from 'components/molecules/FormWrapper';

import { useDateLimit } from 'hooks/statniSprava/useDateLimit';
import { useFormBasics } from 'hooks/statniSprava/useFormBasics';

import isinValidation from 'utils/validations/isinValidation';

import AlertComponent from './AlertComponent';
import IsinTable from './IsinTable';
import OdeslaniPozadavkuRows from './odeslaniPozadavkuRows';

interface IF26 {}

const F26: React.FC<IF26> = () => {
    // page64b
    const [form] = Form.useForm();
    const [, dateLoading, commonDisabledDate] = useDateLimit();
    const [showIsinTable, setShowIsinTable] = useState<boolean>(false);

    const [
        errMsg,
        currentStep,
        idSluzby,
        upozorneni,
        loading,
        odeslaniResp,
        setErrMsg,
        prev,
        onFormSubmit,
        showPxKlicLoadingMsg
    ] = useFormBasics();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        const dataToSend = {
            ...fieldsValue,
            dtod: fieldsValue.dtod.format('YYYY-MM-DD'),
            dtdo: fieldsValue.dtdo.format('YYYY-MM-DD')
        };
        onFormSubmit(dataToSend);
    };
    return (
        <LoadingWrapper loading={loading} loadingText={showPxKlicLoadingMsg ? 'LOADING_PXKLIC' : 'NACITANI'}>
            <Title level={4} text="DUVERNE_INFO_TITLE_F26" />{' '}
            {errMsg ? (
                <>
                    <Paragraph text={errMsg} />
                    <Row>
                        <ButtonComponent
                            id="f26ZpetBtn"
                            type="default"
                            buttontext="ZPET"
                            onClick={() => setErrMsg('')}
                        />
                    </Row>
                </>
            ) : (
                <>
                    {currentStep !== 2 ? (
                        <FormWrapper onFinish={onFinish} outForm={form}>
                            {showIsinTable ? (
                                <IsinTable upperForm={form} setShowIsinTable={setShowIsinTable} formIsinName={'cval'} />
                            ) : (
                                <>
                                    <LoadingWrapper loading={dateLoading}>
                                        <DatePickerComponent
                                            name="dtod"
                                            label="ME_POZADAVKY_DATUM1"
                                            disabled={currentStep > 0}
                                            disabledDate={current =>
                                                current > form.getFieldValue('dtdo') || commonDisabledDate(current)
                                            }
                                        />
                                        <DatePickerComponent
                                            name="dtdo"
                                            disabled={currentStep > 0}
                                            label="ME_POZADAVKY_DATUM2"
                                            disabledDate={current =>
                                                current < form.getFieldValue('dtod') || commonDisabledDate(current)
                                            }
                                        />
                                    </LoadingWrapper>
                                    <InputComponent
                                        disabled={currentStep > 0}
                                        label="ME_POZADAVKY_CISLO_JEDNACI"
                                        name="actn"
                                        maxLength={30}
                                    />
                                    <InputComponent
                                        disabled={currentStep > 0}
                                        label="ISIN"
                                        name="cval"
                                        type="text"
                                        maxLength={12}
                                        rules={isinValidation()}
                                        capitalize={true}
                                    />
                                    {currentStep === 0 && (
                                        <>
                                            <ButtonComponent
                                                id="f26IsinBtn"
                                                buttontext="DUVERNE_INFO_ISIN_BUTTON"
                                                onClick={() => setShowIsinTable(true)}
                                                style={{
                                                    position: 'relative',
                                                    top: -12
                                                }}
                                            />

                                            <ButtonComponent
                                                id="f26OdeslatBtn"
                                                buttontext="ODESLAT"
                                                onClick={() => form.submit()}
                                            />
                                        </>
                                    )}
                                    {currentStep !== 0 && upozorneni && (
                                        <AlertComponent
                                            upozorneni={upozorneni}
                                            type={currentStep === 1 ? 'error' : 'info'}
                                        />
                                    )}
                                    {currentStep === 1 && (
                                        <Row>
                                            <ButtonComponent
                                                id="f26ZpetAltBtn"
                                                buttontext="ZPET"
                                                onClick={() => prev()}
                                                type="default"
                                                style={{
                                                    marginRight: 10
                                                }}
                                            />

                                            <ButtonComponent
                                                id="f26PotvrditBtn"
                                                buttontext="POTVRDIT"
                                                onClick={() => form.submit()}
                                            />
                                        </Row>
                                    )}
                                </>
                            )}
                        </FormWrapper>
                    ) : (
                        <>
                            <OdeslaniPozadavkuRows idSluzby={idSluzby} datum={odeslaniResp?.datum} />
                            {upozorneni && <AlertComponent upozorneni={upozorneni} type={'info'} />}
                        </>
                    )}{' '}
                </>
            )}
        </LoadingWrapper>
    );
};

export default F26;
